import axios from "axios";
import { Base_URL } from "../url";

export const fetchItemGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroup1/GetAllItemGroups`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups!";
  }
};

export const downloadItemGroupsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup1/DownloadItemGroupsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading item groups data!";
  }
};